<template>
  <div id="payPage">
    <router-view />
  </div>
</template>

<script>
export default {};
</script>

<style>
#activity{
  height: 100%;
}
</style>